import { createFileRoute } from "@tanstack/react-router";
import { PublicReceiptPage } from "@/components/sales/PublicReceiptPage";

export const Route = createFileRoute("/r/$token")({
  component: ReceiptRoute,
});

function ReceiptRoute() {
  const { token } = Route.useParams();
  return <PublicReceiptPage token={token} />;
}
